import { EventItem } from '@model';
import {Component, Input} from "@angular/core";
import {LocalizedDatePipe} from "@pipes";

@Component({
  selector: 'app-event-date-display',
  templateUrl: './event-date-display.component.html',
  styleUrls: ['./event-date-display.component.scss']
})
export class EventDateDisplayComponent {
  @Input() eventItem?: EventItem;

  constructor(private datePipe: LocalizedDatePipe) {}

  checkSameDate(eventItem?: EventItem): boolean {
    if (eventItem?.start && eventItem.end) {
      const startDate = new Date(eventItem.start);
      const endDate = new Date(eventItem.end);
      return startDate < endDate && startDate.getDate() !== endDate.getDate() || startDate.getMonth() !== endDate.getMonth() || startDate.getFullYear() !== endDate.getFullYear();
    }
    return false;
  }

  haveDifferentMonths(eventItem?: EventItem): boolean {
    if (eventItem?.start && eventItem.end) {
      const startDate = new Date(eventItem.start);
      const endDate = new Date(eventItem.end);
      return startDate.getMonth() !== endDate.getMonth() || startDate.getFullYear() !== endDate.getFullYear();
    }
    return false;
  }

  haveDifferentYears(eventItem?: EventItem): boolean {
    if (eventItem?.start && eventItem.end) {
      const startDate = new Date(eventItem.start);
      const endDate = new Date(eventItem.end);
      return startDate.getFullYear() !== endDate.getFullYear();
    }
    return false;
  }

  formatDate(date: Date | string): string {
    const dateObj = new Date(date);
    const formatted = this.datePipe.transform(dateObj, 'MMM');
    return formatted ? formatted.charAt(0).toUpperCase() + formatted.slice(1).toLowerCase() : '';
  }
}
